import ExtensionService from 'live/services/extension'

import AlarmConfig from './components'

ExtensionService.addAdminMenu({
    name: 'Alarm Configurations',
    url: '#/alarm-config',
    alias: 'alarm-config',
    ico: 'fas fa-exclamation-circle',
    position: 'first-block',
    addRoute: true,
    routeUrl: 'alarm-config',
    component: AlarmConfig
})
